import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { WithUserProfileConsumer } from '../mixins/with-user-profile-consumer';
import '../components/under-construction.js';

@customElement('settings-page')
export class SettingsNewPage extends WithUserProfileConsumer(LitElement) {
  static styles = css`
    /* Add styles here */
  `;

  render() {
    return html` <under-construction></under-construction> `;
  }
}
